import React, { useEffect, useState } from "react";
import { NotifyConfirm } from "../../../../components/notify/Notify";
import { getTTSIntent, removeTTSIntent } from "../../../../apis/TTS/intent.api";
import { path } from "../../../../constants/path";
import { useGetPermissionAccessControl } from "../../../../context/PermissionAccessControl";
import useDebounce from "src/hooks/useDebounce";
import useControlPanel from "src/hooks/useControlPanel";
import TTSIntentControlPanel from "../../components/ControlPanel/TTSIntentControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import TTSIntentPanelOptional from "../../components/ControlPanel/PanelOptional/TTSIntentPanelOptional";
import Pagination from "src/components/Pagination/Pagination";
import TTSIntentTable from "../../components/Table/TTSIntentTable";

const initIntentData = {
  list: [],
  total_record: 0,
};

const titlePage = "TTS Intents";

const TTSIntent = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [intentData, setIntentData] = useState(initIntentData);
  const [filterIntents, setFilterIntents] = useState([]);
  const [type, setType] = useState("success");
  const [contextId, setContextId] = useState("");

  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      contextId,
      type,
      startDate,
      endDate,
      status,
    };

    getTTSIntent(query, (result) => {
      setIntentData({ ...result });
      setFilterIntents([...result.list]);
    });
  }, [contextId, endDate, limit, numberPage, search, startDate, status, type]);

  useEffect(() => {
    setNumberPage(page);
  }, [page, setNumberPage, contextId, type, status]);

  const handleDelete = (intentDeleted) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const foundIntentIndex = intentData.list.findIndex(
          (intent) => intent.id === intentDeleted.id
        );
        if (foundIntentIndex !== -1) {
          removeTTSIntent(intentDeleted.id, (_) => {
            getTTSIntent({}, (result) => {
              setIntentData({ ...result });
              setFilterIntents([...result.list]);
            });
          });
        }
      }
    });
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <TTSIntentControlPanel
        permissionsAccessControl={permissionsAccessControl}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />

        <TTSIntentPanelOptional
          type={type}
          setType={setType}
          contextId={contextId}
          setContextId={setContextId}
        />
      </TTSIntentControlPanel>

      <TTSIntentTable
        permissionsAccessControl={permissionsAccessControl}
        data={filterIntents}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.ttsIntent}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={intentData.total_record}
      />
    </div>
  );
};

export default TTSIntent;
